import { defineComponent as a, createElementBlock as o, openBlock as t, createBlock as n, createCommentVNode as l, createElementVNode as p, unref as i, withCtx as m, createTextVNode as c, toDisplayString as r } from "vue";
import d from "../AppTag.vue.js";
import './WelcomeKit.css';import './RelatedMaterial.css';import '../Button/Base.css';/* empty css                  */
import "../Button/Burger.vue3.js";
import "../Button/Card.vue3.js";
import "../Button/Form.vue3.js";
import "../Button/ReadMore.vue3.js";
/* empty css                     */
/* empty css                */
const s = ["href"], V = /* @__PURE__ */ a({
  __name: "RelatedMaterial",
  props: {
    tag: {},
    title: {},
    to: {}
  },
  setup(f) {
    return (e, u) => (t(), o("a", {
      href: e.to,
      target: "_blank",
      "data-component-name": "Cards.RelatedMaterial"
    }, [
      e.tag.label ? (t(), n(i(d), {
        key: 0,
        variant: "secondary"
      }, {
        default: m(() => [
          c(r(e.tag.label), 1)
        ]),
        _: 1
      })) : l("", !0),
      p("strong", null, r(e.title), 1)
    ], 8, s));
  }
});
export {
  V as default
};
//# sourceMappingURL=RelatedMaterial.vue.js.map
